module.exports = __webpack_public_path__ + "img/stationID.0340df4a.png";